import React from 'react';
import { Container } from 'react-bootstrap';
import { BigCard, Header, Tabela } from '@equipedigitalfloripa/ed-cms/components';
import * as filiadoApi from '../api/filiados';

const Filiado = () => {

  const columns = [
    {
      title: "Nome",
      field: "name",
      sorting: true
    },
    {
      title: "IN .txt",
      field: "_id",
      render: (rowData) =>
        <a href={`${process.env.REACT_APP_API_URL}filiado/txt/${rowData._id}`} download={true}><i className="fas fa-download"/></a>
    },
    {
      title: "RE .txt",
      field: "_id",
      render: (rowData) =>
        <a href={`${process.env.REACT_APP_API_URL}filiado/txt/${rowData._id}/delete`} download={true}><i
          className="fas fa-download" /></a>
    }
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Filiados"} subtitle={"Lista de filiados"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'filiados'}
            columns={columns}
            fetchFunction={filiadoApi.fetchItems}
            removeFunction={filiadoApi.removeItem}
            statusFunction={filiadoApi.statusItem}
            enableSearch
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Filiado
